







































import { Vue, Component } from "vue-property-decorator";
import Loading from "vue-loading-overlay";
import QCustomerNav from "./qNav.vue";
import QCustomerFooter from "./qFooter.vue";
import QGoToOrder from "./qGoToOrder.vue";
import click2Top from "@/common/directives/click2Top";
// import BackToTop from "vue-backtotop";

import "vue-loading-overlay/dist/vue-loading.css";
import "flatpickr/dist/flatpickr.css";
import {namespace} from "vuex-class";
import ChangeUserInfo from "@/views/pages/changeUserInfo.vue";
import CustomerUser from "@/model/customerUser";
const auth = namespace("Auth");
Vue.use(Loading);
@Component({
  name: "CustomerLayout",
  components: {
    QCustomerFooter,
    QCustomerNav,
    QScripts: () => import("@/common/qScripts.vue"),
    QGoToOrder,
    ChangeUserInfo,
  },
  directives: {
    click2Top,
  },
})
export default class CustomerLayout extends Vue {
  @auth.Getter
  public isCustomer!: boolean;
  @auth.Getter
  getCustomerUser!: CustomerUser;

  @auth.Getter
  public isLoginTime!: boolean;

  @auth.Action
  updateIsLoginTime!: (isLoginTime: boolean) => void;

  get titlePage(): string {
    return this.$route.meta.title || "";
  }
  get subTitle(): string {
    return this.$route.meta.subTitle || "";
  }

  public mounted() {
    if (this.isCustomer && this.getCustomerUser.is_changed_password == false) {
      this.updateIsLoginTime(false);

      // show change user info form when password is not changed
      (this.$refs.changeUserInfo as ChangeUserInfo).show();
    }
  }
}
